import React, { useContext, useEffect, useRef, useState } from "react";
import { TMDataContext } from "../../../utils/custom_hooks/TMDataContext";
// import { LeaderboardSelectionInputPropsShape } from "../../interfaces/componentTypes";

export const IncludeLeaderboards: React.FC<any> = ({
  handleLeaderboardSelection,
  leaderboardStatus,
}) => {
  const { t } = useContext(TMDataContext);
  var activeId = "patient-goal-leaderboard-selection";

  return (
    <>
      <input
        name="leaderboardSelection"
        type="checkbox"
        style={{ transform: "scale(1.5)" }}
        checked={leaderboardStatus}
        onChange={handleLeaderboardSelection}
        id={activeId}
      />
      <label
        htmlFor={activeId}
        className="goal-value-preview"
        style={{ marginLeft: "10px" }}
      >
        {t("views.goals.contexts.include_leaderboard")}
      </label>
    </>
  );
};
